import React from 'react'

const InputFilter = ({ columns, setFilterQuery, isExternal, additionalFilter, searchBtnText, isNeedTextInput = true }) => {
  const [searchText, setSearchText] = React.useState('')
  const createSearchInputPlaceHolder = () => {
    let str = searchBtnText === 'جستجو' ? searchBtnText + ' با' : "Search by"
    columns.map((col, i) => {
      if (col.hasFilter) {
        str += i === 0 ? ` ${col.title}` : `,${col.title} `

      }
    })
    return str;
  }

  React.useEffect(() => {
    if (isExternal) {
      const text = handleCreateSearchText(searchText, columns, isExternal, additionalFilter);
      setFilterQuery({ whereConditionText: text })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [additionalFilter, searchText]);

  // const handleSearchText = (e) => {
  //     const text = handleCreateSearchText(e, columns,isExternal,additionalFilter);
  //     setFilterQuery({ whereConditionText: text })
  // }

  return (
    <>
      {isNeedTextInput ?
        <div className={!isExternal ? ' col-lg-5 col-xs-10' : ''}>
          <input
            type="text"
            className='form-control'
            onChange={(e) => setSearchText(e.target.value)}
            placeholder={createSearchInputPlaceHolder()} /></div> : ''
      }
    </>

  )
}

export default InputFilter

const handleCreateSearchText = (text, columns, isExternal = false, additionalFilter = {}) => {
  let searchQueryText = ""

  if (text) {
    columns.forEach((col, i) => {
      if (col.hasFilter) {
        if (searchQueryText === "") searchQueryText += "("

        searchQueryText += searchQueryText === "" || searchQueryText === "(" ?
          `${col.filterProperty ? col.filterProperty : col.property}.ToLower().Contains(\"${text.toLowerCase()}\") ` :
          ` or ${col.filterProperty ? col.filterProperty : col.property}.ToLower().Contains(\"${text.toLowerCase()}\") `

      }
    })
  }

  if (searchQueryText !== "") searchQueryText += ")"
  if (isExternal && Object.keys(additionalFilter).length > 0) {
    Object.keys(additionalFilter).forEach(item => {

      let filterValue = null;
      const field = additionalFilter[item].as ? additionalFilter[item].as : item
      const operation = additionalFilter[item].opr ? additionalFilter[item].opr : '=='
      if (additionalFilter[item].type === 'bool') {
        filterValue = additionalFilter[item].val === "false" ? false : additionalFilter[item].val === "true" ? true : null;
      } else if (additionalFilter[item].type === 'string' || additionalFilter[item].type === 'number') {
        filterValue = additionalFilter[item].val
      } else if (additionalFilter[item].type === 'date') {
        filterValue = additionalFilter[item].val
      }
      if (filterValue !== null) {

        if (searchQueryText !== '') {

          searchQueryText += ` and ${field} ${operation} \"${filterValue}\"`
        } else {
          searchQueryText += `${field} ${operation} \"${filterValue}\"`

        }
      }

    })
  }
  return searchQueryText;

}